app.service('availableServicesModal', function (modal, productCardManager, store, productCardConfig, loading, serviceInfoModal, productLimitedService, stackedModal) {
	let $checkboxes;
	function show(props) {
		const {content, onChange} = props;

		const modalInstance = modal.generate({
			id: 'available-services',
			content,
			callbackOpen() {
				$checkboxes = this.$modal.find('.js-add-service-checkbox');

				this.$modal
					.on('change', '.js-add-service-checkbox', e => handleAddServiceClick(e.currentTarget, onChange))
					.on('click', '.js-service-info', e => handleServiceInfoClick(e.currentTarget, onChange))
					.on('click', '.js-limited-service', handleLimitedServiceClick)
					.on('click', '.js-apply-modal-btn', () => this.close());
			}
		});

		modalInstance.$modal.on('opened', selectActiveServices);

		stackedModal.push(modalInstance);
	}

	function handleAddServiceClick(service, onChange) {
		const serviceId = parseInt(service.value);
		if (service.checked) {
			productCardManager.addService(serviceId);
		} else {
			productCardManager.removeService(serviceId);
		}
		onChange(serviceId);
	}

	function selectActiveServices() {
		$checkboxes
			.filter((i, checkbox) => productCardManager.hasService(parseInt(checkbox.value)))
			.each((i, checkbox) => checkbox.checked = true);
	}

	function handleServiceInfoClick(service, onChange) {
		const serviceId = $(service).data('service-id');

		showServiceInfoModal(serviceId, onChange);
	}

	function showServiceInfoModal(serviceId, onChange) {
		const productId = productCardConfig.getData().id;
		const outletCategoryId = store.data.isOutlet ? store.data.outletCategoryId : undefined;
		loading.start();

		fetchModalServiceInfo(serviceId, productId, outletCategoryId)
			.then(content => {
				stackedModal.push(serviceInfoModal.show({content, onChange}));
			})
			.fail(() => modal.alert('Błąd ładowania informacji o usłudze. Proszę spróbować ponownie.'))
			.always(() => loading.stop());
	}

	function handleLimitedServiceClick() {
		const serviceId = $(this).data('service-id');
		const productId = productCardConfig.getData().activeOutletCategory;

		productLimitedService.load(serviceId, productId);

		UA.pageInteraction('Usługa', 'Sprawdź najbliższy termin - ' + $("#service-name-" + serviceId).text());
	}

	function fetchModalServiceInfo(serviceId, productId, outletCategoryId) {
		return $.ajax({
			url: '/service-front-view.ltr',
			data: {
				serviceId,
				productId,
				outletCategoryId
			}
		});
	}

	return {
		show,
		showServiceInfoModal
	};
});